<template>
  <div id="gifts">
    <!-- 卡券列表 -->
    <ul
      v-infinite-scroll="loadMore"
      infinite-scroll-disabled="loading"
      infinite-scroll-distance="10"
      infinite-scroll-immediate-check="false"
      class="list"
    >
      <li class="item" v-for="(item, index) in list" :key="index">
        <div class="img-box">
          <img src="@/static/images/home/pic_list.png" />
        </div>
        <div class="info">
          <div class="title">
            <span class="tip">{{ item.brand }}</span> {{ item.name }}
          </div>
          <p>有效期至：{{ item.period }}</p>
          <div class="ctrl">
            <p class="contain">
              卡券状态：<span
                v-html="kqState(item.useStatus, item.isExpire)"
              ></span>
            </p>
            <div class="btn" v-show="item.isExpire != 1">
              <mt-button size="large" type="primary" @click="use(item)">
                <span v-html="type(item, 0)"></span>
              </mt-button>
            </div>
          </div>
        </div>
      </li>

      <li>
        <div class="loading" v-show="loading">
          <mt-spinner type="fading-circle"></mt-spinner>
          <p>加载中...</p>
        </div>
        <div class="loading" v-show="loadAll">
          <p>已加载全部</p>
        </div>
      </li>
    </ul>
    <NoData v-show="noData" />
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      list: [], //礼包列表
      loading: false,
      loadAll: false,
      noData: false,
      pageNo: "1",
      pageSize: "10",
      comfirFlag: true,
    };
  },
  mounted() {
    this.getMemberInfo(() => {
      this.queryMemberCardList();
    });
  },
  methods: {
    //查询我的礼包列表接口 queryMemberCardList
    queryMemberCardList(fn) {
      this.post(this.apis.queryMemberCardList, {
        memberId: this.userInfo.memberId,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      })
        .then((response) => {
          if (response.data.retCode == "SUCCESS") {
            this.list = [...this.list, ...response.data.list];
            if (fn) {
              fn();
            }
            if (response.data.list.length == 0 && this.pageNo != 1) {
              this.loadAll = true;
            }
            if (!this.loadAll && response.data.list.length == 0) {
              this.noData = true;
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    loadMore() {
      if (this.loadAll) {
        return;
      }
      this.loading = true;
      this.pageNo++;
      this.queryMemberCardList(() => {
        this.loading = false;
      });
    },
    kqState(useStatus, isPeriod) {
      // 0未使用;1下单成功2下单失败3商户接单成功4商户接单失败5取消订单6商家完工7车主评价
      let ret = "";
      if (isPeriod == 0) {
        switch (parseInt(useStatus)) {
          case 0:
            ret = "未使用";
            break;
          case 1:
            ret = "下单成功";
            break;
          case 2:
            ret = "下单失败";
            break;
          case 3:
            ret = "商户接单成功";
            break;
          case 4:
            ret = "商户接单失败";
            break;
          case 5:
            ret = "取消订单";
            break;
          case 6:
            ret = "商家完工";
            break;
          case 7:
            ret = "车主评价";
            break;
        }
      } else {
        ret = "已过期";
      }
      return ret;
    },
    //卡券使用
    use(item) {
      if (this.userInfo.driverName && this.userInfo.carNum) {
        this.type(item, 1);
        console.log("use -> item", item);
      } else {
        this.$messagebox({
          title: "提示",
          message: "使用卡券前需补充完善基本信息",
          showCancelButton: true,
          confirmButtonText: "确定",
        }).then((action) => {
          if (action == "confirm") {
            if (!this.comfirFlag) {
              return;
            }
            this.comfirFlag = false;
            this.changeRouter("/baseInfo?flag=1");
          } else {
            //取消
          }
        });
      }
    },
    type(item, click) {
      let ret = "-";
      if (
        item.isExpire == 0 &&
        item.cardType == 0 &&
        item.interfaceCallStatus == 1 &&
        (item.useStatus == 0 ||
          item.useStatus == 2 ||
          item.useStatus == 4 ||
          item.useStatus == 5)
      ) {
        ret = "使用";
        if (click == 1) {
          this.post(this.apis.toUseCard, {
            cardId: item.id,
          })
            .then((response) => {
              if (response.data.retCode == "SUCCESS") {
                // this.detail = response.data;
                window.location.href = response.data.url;
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      } else if (item.isExpire == 0 && item.cardType == 1) {
        ret = "使用";
        //请持当前卡券去线下服务点使用
        if (click == 1) {
          this.$toast({
            message: "请持当前卡券去线下服务点使用",
            duration: 1800,
          });
        }
      } else if (
        item.isExpire == 0 &&
        item.cardType == 0 &&
        item.interfaceCallStatus == 1 &&
        (item.useStatus == 1 ||
          item.useStatus == 3 ||
          item.useStatus == 6 ||
          item.useStatus == 7)
      ) {
        ret = "查看";
        if (click == 1) {
          this.post(this.apis.toShowCard, {
            cardId: item.id,
          })
            .then((response) => {
              if (response.data.retCode == "SUCCESS") {
                // this.detail = response.data;
                window.location.href = response.data.url;
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }
      if (click == 0) {
        return ret;
      }
    },
    ...mapMutations(["setUserInfo"]),
  },
  computed: {
    ...mapState(["openIdKey", "userInfo"]),
  },
};
</script>

<style lang="less" scoped>
#gifts {
  .list {
    padding: 30px 30px 0;
    margin: 0 auto;
    .item {
      width: 691px;
      height: 240px;
      background-color: #ffffff;
      box-shadow: 0px 0px 10px 0px rgba(163, 163, 163, 0.45);
      border-radius: 10px;
      display: flex;
      align-items: center;
      margin-bottom: 26px;
      .img-box {
        flex: 0 0 187px;
        height: 170px;
        display: flex;
        align-items: center;
        margin-left: 18px;
        margin-right: 18px;
        img {
          max-width: 100%;
          max-height: 100%;
        }
      }
      .info {
        height: 186px;
        .title {
          font-family: PingFang-SC-Bold;
          font-weight: bold;
          color: #3a3a3a;
          font-size: 30px;
          width: 440px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding-top: 15px;
          .tip {
            display: inline-block;
            padding: 0 10px;
            margin-right: 10px;
            background-color: #1fbe6e;
            border-radius: 4px;
            font-family: PingFang-SC-Regular;
            font-size: 24px;
            line-height: 42px;
            color: #fff;
            text-align: center;
          }
        }
        p {
          padding-top: 16px;
          padding-bottom: 16px;
          font-family: PingFang-SC-Regular;
          color: #3a3a3a;
        }
        .ctrl {
          width: 450px;
          p {
            padding-top: 0;
            &.contain {
              flex: 0 0 300px;
            }
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 64px;
          .btn {
            .mint-button--large {
              width: 160px;
              height: 53px;
            }
          }
        }
      }
    }
  }
}
</style>
